import { ActionType, RootAction } from '@/actions/actiontypes';
import { LoginWindowState } from '@/state';

const initialState = LoginWindowState.NONE;

export const loginWindowReducer = (
    loginWindowState: LoginWindowState = initialState,
    action: RootAction
) => {
    switch (action.type) {
        case ActionType.SHOW_LOGIN:
            return action.state;
        default:
            return loginWindowState;
    }
};
